import { createStore } from 'redux';

import { composeWithDevTools } from 'redux-devtools-extension';

import analyticsReducer from '../reducers/analyticsReducer';
import { ANALYTICS_COLORS } from '../constants/constants';

const createAnalyticsStore = (props: any) => {
  const defaultProps = {
    participation: {
      data: [],
      totalEngagements: 0,
      totalEngagement: 0,
      requestStatus: 'loading',
    },
    leaderboard: {
      colors: ANALYTICS_COLORS.reverse(),
      data: [],
      requestStatus: 'loading',
    },
    organization: {
      data: {},
      requestStatus: 'loading',
    },
    bonuses: {
      bonusesGiven: 0,
      bonusesReceived: 0,
      colors: ANALYTICS_COLORS,
      data: {},
      pointsGiven: 0,
      uniqueHashtags: 0,
      requestStatus: 'loading',
    },
    topWords: {
      data: [],
      requestStatus: 'loading',
    },
  };

  const preloadedState = { ...defaultProps, ...props };
  const store = createStore(analyticsReducer, preloadedState, composeWithDevTools());

  return store;
};

export default createAnalyticsStore;
